import type { ReactNode } from 'react'
import { cx } from '../cx'
import type { Gap } from './Stack'
import s from './Inline.module.css'

/** Things side by side that wrap onto the next line when there's no room: buttons, chips, a label and its value. */
export function Inline(props: {
  children: ReactNode
  gap?: Gap
  align?: 'center' | 'baseline' | 'start' | 'end'
  justify?: 'start' | 'between' | 'end' | 'center'
  /** Keep on one line (the last child shrinks). Default: wrap. */
  nowrap?: boolean
}) {
  return (
    <div
      className={cx(
        s.inline,
        s[`gap-${props.gap ?? 'sm'}`],
        s[`align-${props.align ?? 'center'}`],
        s[`justify-${props.justify ?? 'start'}`],
        props.nowrap && s.nowrap,
      )}
    >
      {props.children}
    </div>
  )
}
